import { render } from "./Clients.vue?vue&type=template&id=bb6ceb60"
import script from "./Clients.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Clients.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script